GP.vent.on('init_js:feedback', function(self) {
    $('body').on("click", "#btn-feedback-close", function(e){
        $('#btn-feedback').remove();
        GP.Util.set_cookie('fl_feedback', 1, 7);
        e.stopImmediatePropagation();
        return false;
    });
});
